import { Box, Button, Paper, Typography } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useLocation, useNavigate } from "react-router-dom";

const NotAuthorized = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const attemptedPath = location.state?.from;

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
      return;
    }
    navigate("/", { replace: true });
  };

  return (
    <Box
      minHeight="70vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
      padding={3}
      bgcolor="#f9f9ff"
    >
      <Paper
        elevation={0}
        sx={{
          width: "100%",
          maxWidth: 560,
          borderRadius: 4,
          border: "1px solid #E4E4F4",
          p: { xs: 3, md: 5 },
          textAlign: "center"
        }}
      >
        <Box
          width={72}
          height={72}
          borderRadius="50%"
          display="flex"
          alignItems="center"
          justifyContent="center"
          margin="0 auto 24px"
          bgcolor="#ECECFF"
          color="#4444B2"
        >
          <LockOutlinedIcon sx={{ fontSize: 38 }} />
        </Box>

        <Typography variant="h4" fontWeight={700} color="#303060" gutterBottom>
          No tienes autorización para esta pantalla
        </Typography>

        <Typography color="text.secondary" fontSize={16} lineHeight={1.7} mb={2}>
          Tu usuario no tiene los roles necesarios para navegar por esta sección.
          Si necesitas acceder, solicita al administrador que revise los roles
          asignados a tu cuenta.
        </Typography>

        {attemptedPath ? (
          <Typography color="text.secondary" fontSize={13} mb={3}>
            Ruta solicitada: <strong>{attemptedPath}</strong>
          </Typography>
        ) : null}

        <Button
          variant="contained"
          size="large"
          startIcon={<ArrowBackIcon />}
          onClick={handleBack}
          sx={{
            bgcolor: "#4444B2",
            borderRadius: 2,
            px: 4,
            textTransform: "none",
            fontWeight: 700,
            "&:hover": {
              bgcolor: "#35359A"
            }
          }}
        >
          Volver a la página anterior
        </Button>
      </Paper>
    </Box>
  );
};

export default NotAuthorized;
